import { type FC, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useSnackbar } from "notistack";
import { ConfirmDialog } from "@/admin/shared/ui";
import { useTerminateProductPurchaseMutation } from "@/admin/entities/productPurchases";

interface TerminatePurchaseButtonProps {
  id: string;
  expiredAt: string;
}

/**
 * Остановка покупки: доступ истекает сейчас, автопродление подписки
 * выключается (референс whitelabelAdmin TerminateProductPurchase).
 * У истёкшей покупки останавливать нечего, кнопки нет.
 */
export const TerminatePurchaseButton: FC<TerminatePurchaseButtonProps> = ({
  id,
  expiredAt,
}) => {
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const [terminate, { loading, error }] = useTerminateProductPurchaseMutation({
    variables: { id },
    refetchQueries: ["ProductPurchasesList"],
    onCompleted: () => {
      enqueueSnackbar("Покупка остановлена", { variant: "success" });
      setOpen(false);
    },
    onError: () => {
      // ошибка уже отображается через ErrorMessage внутри ConfirmDialog
    },
  });

  if (new Date(expiredAt).getTime() <= Date.now()) return null;

  return (
    <>
      <Tooltip title="Остановить покупку">
        <span>
          <IconButton
            size="small"
            disabled={loading}
            onClick={(event) => {
              event.stopPropagation();
              setOpen(true);
            }}
          >
            <ClearIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <ConfirmDialog
        open={open}
        loading={loading}
        error={error}
        delay={5}
        onCancel={() => setOpen(false)}
        onConfirm={() => {
          void terminate();
        }}
        confirmTitle="Остановить покупку"
        confirmText="Контент перестанет быть доступен зрителю, автопродление подписки выключится."
      />
    </>
  );
};
